import { render, staticRenderFns } from "./LgFormSelect.vue?vue&type=template&id=26b3b012&scoped=true"
import script from "./LgFormSelect.vue?vue&type=script&lang=js"
export * from "./LgFormSelect.vue?vue&type=script&lang=js"
import style0 from "./LgFormSelect.vue?vue&type=style&index=0&id=26b3b012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b3b012",
  null
  
)

export default component.exports